import { useMemo } from "react";
import {
  GoogleCalendarEventColourIds,
  type GoogleCalendarEventColourId,
} from "./GoogleCalendarSourceSettings.types";

export interface GoogleCalendarSourceSettingsText {
  calendarsLabelText: string;
  calendarsPlaceholderText: string;
  calendarsHintText: string;
  colourLabelText: string;
  colourHintText: string;
  colourNotSetText: string;
  loadingText: string;
  loadErrorText: string;
  colourNames: Record<GoogleCalendarEventColourId, string>;
}

export const useGoogleCalendarSourceSettingsText = (
  t: (key: string) => string,
): GoogleCalendarSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.googleCalendar.${key}`);

    const colourNames = Object.fromEntries(
      GoogleCalendarEventColourIds.map((id) => [id, tKey(`colours.${id}`)]),
    ) as Record<GoogleCalendarEventColourId, string>;

    return {
      calendarsLabelText: tKey("calendarsLabel"),
      calendarsPlaceholderText: tKey("calendarsPlaceholder"),
      calendarsHintText: tKey("calendarsHint"),
      colourLabelText: tKey("colourLabel"),
      colourHintText: tKey("colourHint"),
      colourNotSetText: tKey("colourNotSet"),
      loadingText: tKey("loading"),
      loadErrorText: tKey("loadError"),
      colourNames,
    };
  }, [t]);
};
